import type { IntakeHealthAttentionItem } from './api';

/**
 * Banner selector for intake attention rows. Failed rows get the red section
 * with Retry; parsed_with_warnings rows get the amber section (warning strings
 * verbatim, View PDF, NO Retry — the reparse endpoint is failed-only and would
 * 409). Stuck-pending rows are returned by the health endpoint but render in
 * neither section (the sweeper flips them to failed within one cron tick).
 */
export function splitIntakeAttention(items: IntakeHealthAttentionItem[]): {
  failed: IntakeHealthAttentionItem[];
  warned: IntakeHealthAttentionItem[];
} {
  return {
    failed: items.filter((a) => a.parse_status === 'failed'),
    warned: items.filter((a) => a.parse_status === 'parsed_with_warnings'),
  };
}
